module.exports = __webpack_public_path__ + "static/media/nib-logo.f12809dd.svg";